module.exports = __webpack_public_path__ + "static/firdaus-intro-53b8d782ad481ae972c6b8ecbec1ab97.jpg";